import React from "react";
const TimeRangeOptionsSummary = ({ options }) => {
  let timerangeOptionsSummary = null;
  if (options) {
    timerangeOptionsSummary = Object.keys(options).map((key) => /* @__PURE__ */ React.createElement("span", { key: `timerange-options-summary-${key}` }, /* @__PURE__ */ React.createElement("dt", null, key), /* @__PURE__ */ React.createElement("dd", null, options[key])));
  }
  return /* @__PURE__ */ React.createElement("dl", { className: "deflist" }, timerangeOptionsSummary);
};
export default TimeRangeOptionsSummary;
